<template>
  <form class="pa-message-additional-box">
    <button
      v-for="item in multipleButtons"
      :key="item.slug"
      type="submit"
      class="button pa-block-button"
      :class="item.buttonClass"
      :disabled="item.isDisabledButton"
      @click.prevent="handleClick(item.slug)"
    >{{item.buttonText}}</button>
  </form>
</template>

<script>
export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    }
  },

  data(){
    return {
      multipleButtons : [
        {
          slug              : 'start-full-tutorial',
          buttonClass       : [],
          isDisabledButton  : false,
          buttonText        : 'すべてのチュートリアルを開始',
        },

        {
          slug              : 'start-home-tutorial',
          buttonClass       : [],
          isDisabledButton  : false,
          buttonText        : 'マイページのみ開始',
        },

        {
          slug              : 'start-office-tutorial',
          buttonClass       : [],
          isDisabledButton  : false,
          buttonText        : '事務所のみ開始',
        },

        {
          slug              : 'start-park-tutorial',
          buttonClass       : [],
          isDisabledButton  : false,
          buttonText        : 'ひろばのみ開始',
        },

        {
          slug              : 'start-connection-tutorial',
          buttonClass       : [],
          isDisabledButton  : false,
          buttonText        : 'メルティングポッドのみ開始',
        }
      ]
    };
  },

  watch : {
    isDisabled  : {
      handler(value){
        if(value === true){
          for(let i = 0; i < this.multipleButtons.length; i++){
            this.multipleButtons[i].isDisabledButton = true;
            this.multipleButtons[i].buttonClass = ['button-disabled'];
          }
        }else{
          for(let i = 0; i < this.multipleButtons.length; i++){
            this.multipleButtons[i].isDisabledButton = false;
            this.multipleButtons[i].buttonClass = [];
          }
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          for(let i = 0; i < this.multipleButtons.length; i++){
            this.multipleButtons[i].isDisabledButton = true;
            this.multipleButtons[i].buttonClass = ['is-loading'];
          }
        }else{
          for(let i = 0; i < this.multipleButtons.length; i++){
            this.multipleButtons[i].isDisabledButton = false;
            this.multipleButtons[i].buttonClass = [];
          }
        }
      },
      immediate: true
    },
  },

  methods : {
    handleClick(buttonSlug){
      this.$emit('onSubmit', null, buttonSlug);
    }
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
  .pa-message-additionals{
    .pa-message-additional-box{
      button.button{
        &.pa-block-button{
          display: block;
          margin-top:6px;
          font-size:.85rem;
        }
      }
    }
  }
</style>